var _path, _rect, _path2, _rect2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIphone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 431,
    height: 864,
    viewBox: "0 0 431 864",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M428 300V781.956C428 810.484 425.03 820.829 419.452 831.259C413.874 841.689 405.689 849.874 395.259 855.452C384.829 861.03 374.484 864 345.956 864H85.0443C56.5157 864 46.1706 861.03 35.7409 855.452C25.3113 849.874 17.1261 841.689 11.5482 831.259C5.97042 820.829 3 810.484 3 781.956V321C1.34315 321 0 319.657 0 318V260C0 258.343 1.34315 257 3 257V242C1.34315 242 0 240.657 0 239V181C0 179.343 1.34315 178 3 178V151C1.34315 151 0 149.657 0 148V120C0 118.343 1.34315 117 3 117V82.0443C3 53.5157 5.97042 43.1706 11.5482 32.7409C17.1261 22.3113 25.3113 14.1261 35.7409 8.54825C46.1706 2.97042 56.5157 0 85.0443 0H345.956C374.484 0 384.829 2.97042 395.259 8.54825C405.689 14.1261 413.874 22.3113 419.452 32.7409C425.03 43.1706 428 53.5157 428 82.0443V199C429.657 199 431 200.343 431 202V297C431 298.657 429.657 300 428 300ZM27 87.8C27 66.518 27 55.877 31.1418 47.7484C34.7849 40.5982 40.5982 34.7849 47.7484 31.1418C55.877 27 66.518 27 87.8 27L103 27C106.684 27.0098 109.732 29.865 109.998 33.4837C110.14 38.4568 111.1 42.1066 112.785 45.2569C114.615 48.6791 117.301 51.3649 120.723 53.1951C124.145 55.0253 128.157 56 133.814 56H295.146C300.803 56 304.815 55.0253 308.237 53.1951C311.659 51.3649 314.345 48.6791 316.175 45.2569C317.857 42.1117 318.817 38.4686 318.961 33.5079C319.216 29.8778 322.269 27.0098 325.961 27L341.2 27C362.482 27 373.123 27 381.252 31.1418C388.402 34.7849 394.215 40.5982 397.858 47.7484C402 55.877 402 66.518 402 87.8V778.2C402 799.482 402 810.123 397.858 818.252C394.215 825.402 388.402 831.215 381.252 834.858C373.123 839 362.482 839 341.2 839H87.8C66.518 839 55.877 839 47.7484 834.858C40.5982 831.215 34.7849 825.402 31.1418 818.252C27 810.123 27 799.482 27 778.2V87.8Z",
    fill: "white"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 149,
    y: 825,
    width: 134,
    height: 5,
    rx: 2.5,
    fill: "#CBCBD3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M261 42C264.866 42 268 38.866 268 35C268 31.134 264.866 28 261 28C257.134 28 254 31.134 254 35C254 38.866 257.134 42 261 42Z",
    fill: "#CBCBD3"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 189,
    y: 31,
    width: 52,
    height: 8,
    rx: 4,
    fill: "#CBCBD3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIphone);
export default __webpack_public_path__ + "static/media/iphone.a3a0df58.svg";
export { ForwardRef as ReactComponent };